export const POPUP_FIELD_INFOS = [
  { fieldName: 'Name', label: 'Name' },
  { fieldName: 'UsageCount', label: 'Usage Count' },
  { fieldName: 'total_trav', label: 'Total Travel' },
  { fieldName: 'Total_Time', label: 'Total Time' }
]

export const CLASS_BREAK_COLORS = ['#FFF999', '#FFD37F', '#E69800', '#A83800']

export const ROAD_FREQUENCY_BREAK_COLORS = ['#FFF999', '#FFD37F', '#E69800', '#A83800']

export const DESTINATIONS_FREQUENCY_BREAK_COLORS = ['#FFFFBE', '#FFD37F', '#E69800', '#A83800']

export const CONNECTIVITY_TRAVEL_LENGTH_BREAK_COLORS = ['#FFFFBE', '#FFD37F', '#E69800', '#A83800']

export const NO_ACCESS_COLOR = '#D3D3D3'

export const NO_ACCESS_ROAD_FREQUENCY_BREAK_COLORS = '#D3D3D3'

export const NO_ACCESS_DESTINATIONS_FREQUENCY_BREAK_COLORS = '#D3D3D3'

export const NO_ACCESS_CONNECTIVITY_TRAVEL_LENGTH_BREAK_COLORS = '#D3D3D3'

export const LEGEND_ITEMS = [
  { color: '#b95f4c', label: 'Very low' },
  { color: '#f69a73', label: 'Low' },
  { color: '#f2da95', label: 'Moderate' },
  { color: '#ffffff', label: 'Good' },
  { color: '#050707', label: 'No access' }
]

export const BACK_END_SERVER_DOMAIN = import.meta.env.VITE_APP_API_BASE_URL

export function generatePrintServiceUrl(id: number): string {
  return `${BACK_END_SERVER_DOMAIN}/print-service/${id}/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task`
}
